import { useEffect, useState } from "react";

export const ComparacionSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);
  return (
    <select
      className="select-comparacion"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="CT">Fecha de Cotización</option>
      <option value="VG">Vigencia</option>
      <option value="VT">Fecha de Venta</option>
    </select>
  );
};
